let carga: Promise<HTMLImageElement | null> | null = null;

/** SVG local precacheado. Si falla, la placa conserva el nombre en texto. */
export function cargarSimbolo(): Promise<HTMLImageElement | null> {
  if (!carga) {
    carga = new Promise((resolver) => {
      const imagen = new Image();
      imagen.onload = () => resolver(imagen);
      imagen.onerror = () => {
        carga = null;
        resolver(null);
      };
      imagen.src = '/marca/simbolo.svg';
    });
  }
  return carga;
}

/** Devuelve el inicio del texto, dejando espacio para el símbolo. */
export function simboloEnCabecera(
  c: CanvasRenderingContext2D,
  imagen: HTMLImageElement | null,
  x: number,
  y: number,
): number {
  if (!imagen) return x;
  c.drawImage(imagen, x, y - 45, 54, 48);
  return x + 72;
}
